// TODO - remove lint disable when editing this file
/* eslint-disable */
import * as R from 'ramda'

const COMMENT_REGEXP = /<dfn[^>]*>((?:(?:(?!<\/dfn>).)|[\r\n])*)<\/dfn>/g
const CLEANUP_REGEXP = /<[^>]*>/g

// get an object with input as a paragraph string with inline comments and
// produce result array with cleaned up comments and their locations
const extractCommentsFromText = (context) => {
  const { input = '', result = [] } = context
  const [{ pos = 0 } = {}] = result

  COMMENT_REGEXP.lastIndex = 0

  const match = COMMENT_REGEXP.exec(input)

  if (!match) {
    return { result }
  }

  const comment = match[0]
  const remaining = input.slice(match.index + comment.length)
  const matchIndex = match.index + pos
  const updatedResult = [
    {
      pos: matchIndex,
      comment: comment.replace(CLEANUP_REGEXP, ''),
    },
    ...result,
  ]
  return { input: remaining, result: updatedResult }
}
/// // Inline Comment extractor part
// Execute extractCommentsFromText function until it has non-empty
// input field in a input object
const extractCommentsUntilInputFunctor = R.until(
  R.compose(
    R.not,
    R.prop('input')
  ),
  extractCommentsFromText
)

// Create accessor to go over object, pick 'content' and set result into 'inline_comments'
const commentExctractorLens = R.lens(
  R.propOr('', 'content'),
  R.assocPath(['additional_properties', 'inline_comments'])
)

// get an input string, pass it to extractCommentsUntilInputFunctor and return result prop from
// the extractCommentsUntilInputFunctor return value
const commentExctractorFunctor = (input) =>
  R.prop('result')(extractCommentsUntilInputFunctor({ input }))

// Create a function, which gets commentExctractorLens and apply commentExctractorFunctor
// Other words, it gets 'content' value from passed obj, call commentExctractorFunctor
// and write result into inline_comments. (see commentExctractorLens)
const commentExctractor = R.over(
  commentExctractorLens,
  commentExctractorFunctor
)

/// // Inline Comments remover part
const replaceInlineComments = (comment) =>
  comment && comment.replace(COMMENT_REGEXP, '')
// return functor which gets an object and apply replaceInlineComments function to it's 'content' field
// putting result back
const removeInlineComments = R.evolve({ content: replaceInlineComments })

// Go over contentElements array and apply comment extractor and content remover functions
// returning
export const deflateInlineComments = (contentElements = []) => {
  const contentElementsHasNoInlineComments = R.all(
    R.pathSatisfies(R.isNil, ['additional_properties', 'inline_comments'])
  )

  return R.ifElse(
    contentElementsHasNoInlineComments,
    R.map(
      R.compose(
        removeInlineComments,
        commentExctractor
      )
    ),
    R.identity
  )(contentElements)
}

// Insert comment into string
const inlineCommentReducer = (content, comment) =>
  content.slice(0, comment.pos) +
  `<dfn>${comment.comment}</dfn>` +
  content.slice(comment.pos)

// Create reverse sorter for inline comments
const reverseSortByPos = R.compose(
  R.reverse,
  R.sortBy(R.prop('pos'))
)

// Process content by reversing comments by position and applying
// reducer
export const processInlineComments = (reducer) => (content, inine = []) => {
  if (!content && !inine.length) {
    return content
  }
  return R.compose(
    R.reduce(reducer)(content),
    reverseSortByPos
  )(inine)
}

// Process content_elements by getting content and additional_properties.inline_comments
// and passing in to the processComments
const contentElementMapper = (obj = {}) => {
  // Skip bogus inline comments applied to the list container with no content
  if (!obj.content && typeof obj.content !== 'string') {
    return obj
  }

  obj.content = R.converge(processInlineComments(inlineCommentReducer), [
    R.propOr('', 'content'),
    R.pathOr([], ['additional_properties', 'inline_comments']),
  ])(obj)
  return obj
}

// inflate inline comments and remove inline_comments from additional_properties
const processContentElements = R.map(
  R.compose(
    R.evolve({ additional_properties: R.dissoc('inline_comments') }),
    contentElementMapper
  )
)

export const inflateInlineComments = (story) => {
  if (!story) {
    return Promise.reject(
      new Error('inflateInlineComments provided with empty story')
    )
  }
  // Check if all content_elements has no diff.change items
  const storyHasNoDiffs = R.compose(
    R.all(R.pathSatisfies(R.isNil, ['diff', 'change'])),
    R.path(['content_elements'])
  )

  const processInlineComments = R.evolve({
    content_elements: processContentElements,
  })

  // Check for diffs, if any, just return unchanged story back
  return Promise.resolve(
    R.ifElse(storyHasNoDiffs, processInlineComments, R.identity)(story)
  )
}
